import { v4 as uuidv4 } from "uuid";
export function createUid() {
  const uuid = uuidv4();
  return uuid.replace(new RegExp("-", "g"), "");
}
